export * from "./aspects.component";
